import { Injectable, inject } from "@angular/core";
import { Actions } from "@ngrx/effects";
// import { platformTestAction } from "./platform.actions";

@Injectable()
export class PlatformEffects {
    private actions$ = inject(Actions);

    // test$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(platformTestAction),
  //     tap(({ test }) => {
  //       console.log(test);
  //     })
  //   ),
  //   { dispatch: false }
  // )
}
